import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const GARAN_IMG = '/legal/eu-garan-label.jpg';
const GARAN_INFO = 'https://europa.eu/youreurope/citizens/consumers/shopping/commercial-guarantee-durability/index_ro.htm';

/**
 * Eticheta GARAN armonizată a UE — obligatorie DOAR când producătorul oferă gratuit o garanție
 * comercială de durabilitate care acoperă întregul produs și depășește 2 ani.
 * Dacă producătorul a furnizat eticheta finală (garanLabelUrl), aceasta se afișează ca atare;
 * altfel se folosește eticheta oficială, iar cele 3 elemente editabile (durata, marca, modelul)
 * sunt afișate explicit lângă ea.
 */
export const GaranLabel = ({ years, brand, model, labelUrl }) => {
  const [open, setOpen] = useState(false);
  if (!years || Number(years) <= 2) return null;

  return (
    <div className="rounded-xl border border-blue-200 bg-blue-50/70 overflow-hidden" data-testid="garan-label">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 px-3 py-2.5 text-left hover:bg-blue-100/60 transition-colors"
        data-testid="garan-label-toggle"
      >
        <span className="text-xs font-extrabold tracking-wider text-blue-900 bg-white border border-blue-300 rounded px-1.5 py-0.5">
          GARAN
        </span>
        <span className="flex-1 text-sm font-medium text-blue-900">
          Garanție de durabilitate {years} ani de la producător
          <span className="block text-[11px] font-normal text-blue-800/80">
            gratuită, acoperă întregul produs · apasă pentru etichetă
          </span>
        </span>
        <ChevronDown className={`h-4 w-4 text-blue-700 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="px-3 pb-3 space-y-2" data-testid="garan-label-content">
          <img
            src={labelUrl || GARAN_IMG}
            alt={`Eticheta GARAN a UE — garanție de durabilitate ${years} ani`}
            className="w-44 mx-auto rounded-lg border border-blue-200 bg-white"
            data-testid="garan-label-image"
          />
          <div className="text-[11px] text-gray-700 leading-relaxed">
            <div><strong>Durata:</strong> {years} ani</div>
            {brand && <div><strong>Marca:</strong> {brand}</div>}
            {model && <div><strong>Model:</strong> {model}</div>}
            <p className="mt-1">
              Garanția comercială de durabilitate este oferită de producător, nu înlocuiește și nu
              limitează garanția legală de conformitate de minimum 2 ani.{' '}
              <a href={GARAN_INFO} target="_blank" rel="noopener noreferrer"
                 className="text-blue-700 underline" data-testid="garan-label-eu-link">
                Ce înseamnă eticheta GARAN
              </a>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default GaranLabel;
